module.exports = __webpack_public_path__ + "7298676cf3c6166a406cb24f2f6ba53c.jpg";